var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9DABC9",
  fillRule: "evenodd",
  d: "m18.75 11-.006.243.006.257-.006.245.006.255-.189 8.253a2.05 2.05 0 0 1-1.826 1.989c-3.147.34-6.323.34-9.47 0a2.05 2.05 0 0 1-1.827-1.989L5.25 12l.006-.257-.006-.243.006-.256L5.25 11l.168-6.641.007-.131.01-.462A2.1 2.1 0 0 1 7.32 1.728q.131-.014.262-.027a3 3 0 0 1 .365-.06 41.8 41.8 0 0 1 8.106 0q.186.02.364.06l.263.027a2.1 2.1 0 0 1 1.884 2.037l.011.464q.005.064.006.13zM16 17.75a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5zm-4 3.95a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  clipRule: "evenodd"
})));
export default SvgMobile;